import styled from 'styled-components';
import { TabButton as DefaultTabButton } from '~/pages/Analysis/SchedulesModals/styles';

export const TabButton = styled(DefaultTabButton)<{ activeTab: boolean }>`
  text-align: center;
  font-size: 90%;
  padding: 4px 1px;
  border-right: 1px solid lightgrey;
  border-left: 1px solid lightgrey;

  ${({ activeTab }) => (activeTab ? `
    border-bottom: none;
    background-color: transparent;
    cursor: default;
    font-weight: bold;
  ` : `
    border-bottom: 1px solid lightgrey;
    background-color: #F4F4F4;
    cursor: pointer;
    font-weight: normal;
  `)}
`;
